// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';

/* NOTE: if changing this, make sure that
   https://grok.dev.tripadvisor.com/xref/interactions-tracking/src/main/resources/exports/com/tripadvisor/service/interactions/search.yaml
   also gets updated */
type SearchTrackingContext = {|
  searchSessionId: string,
  sid: string,
  rf: string,
  userId?: string,
|};

/** null value if context does not exist */
// $FlowFixMe92
export default React.createContext((null: ?SearchTrackingContext));
